module.exports = __webpack_public_path__ + "static/media/editpencil.4334850c.svg";